import Cookies from "js-cookie";
export const logout = (history) => {
  Cookies.remove("para-admin_ufo");
  Cookies.remove("paraAdmin_auth_token");
  return history("/auth/login");
};
